// Kept apart from services/apiService.js on purpose: components that only need an
// address (avatars) should not pull in axios and the API client, which tests mock
// wholesale.
const API_URL = process.env.REACT_APP_API_URL || '/api';

/**
 * A full address for a path the API hands back relative to its root, such as a
 * profile photo's photo_url ('/users/12/photo?v=...'). For plain <img> tags, which
 * do not go through axios and its baseURL.
 */
export const apiAssetUrl = (path) => (path ? `${API_URL}${path}` : null);
